// 对冲金额流程详情
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
      <span>金额对冲申请</span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="form-box">
      <!-- start of 金额对冲申请 -->
      <div style="position: relative;" class="back-color-fff mt-4">
        <span class="form-title">金额对冲申请</span>
        <span class="form-title" v-if="formData.approveVO&&formData.approveVO.flowNo">- {{ formData.approveVO.flowNo }}</span>
        <el-form :model="formData" label-width="140px"  ref="formData">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item  prop="relevance">
                <span slot="label"> <span style="color: red">*</span>关联流程： </span>
                {{ formData.relevance }}
                <span v-if="formData.relevance" class="file-preview" @click="seeDetail">查看详情</span>
              </el-form-item>
            </el-col>
            <!-- //!应付金额的取数逻辑之前来自结算单的费用总额字段，现在要换成结算单的应付金额 -->
            <el-col :span="8">
              <el-form-item prop="isRepay" >
                <span slot="label"> <span style="color: red">*</span>是否已付款： </span>
                {{ formData.isPaid == 'Y' ? '是' : '否' }}
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.isPaid == 'Y'">
              <el-form-item label="" label-width="160px">
                <span slot="label"> <span style="color: red">*</span>累计已付款金额(元)： </span>
                <span style="color: #ff5f1f">{{ formData.paidAmount === 0 ? '0.00' : formatMoney(formData.paidAmount) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.isPaid == 'Y'">
              <el-form-item label="" label-width="160px">
                <span slot="label"> <span style="color: red">*</span>累计已退回金额(元)： </span>
                <span style="color: #ff5f1f">{{ formData.returnedAmount === 0 ? '0.00' : formatMoney(formData.returnedAmount) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="formData.isPaid == 'Y'">
            <el-col :span="24">
              <el-form-item label="" >
                <span slot="label">
                    退款日期：
                </span>
                {{ formData.returnedDate | getDate}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="" >
                <span slot="label"> 对冲说明： </span>
                <div style="width: 600px">
                  <span style="color: red;">{{ formData.memo }}</span><span>{{ formData.memo ?'': '-' }}</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <img
          v-show="formData.approveVO && formData.approveVO.approveState !== 'N'"
          class="approve-img"
          :src="getApproveImg()"
          alt=""
        />
      </div>
      <!-- end of 金额对冲申请 -->

      <div
        class="back-color-fff mt-4"
        v-show="formData.relevance && refundDetail.length"
      >
        <div class="form-title-box">
          <span class="form-title">退款明细</span>
        </div>
        <div class="content-main-box back-color-fff" style="height: auto;">
          <el-table
            class="ml71"
            style="width: 70%"
            :data="refundDetail"
            stripe
            border
            highlight-current-row
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              width="200"
              prop="payBankName"
              label="付款方银行"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.payBankName || '-'  }}
              </template>
            </el-table-column>
            <el-table-column
              prop="payBankAccount"
              label="付款方银行账户"
            >
              <template slot-scope="scope">
                {{ scope.row.payBankAccount || '-'  }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="payAmount"
              label="已付款金额(元)"
              align="center"
            >
              <template slot-scope="scope">
                <div class="t-right">
                  {{ scope.row.payAmount  | numFmt | numDigit  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="refundAmount"
              label="已退回金额(元)"
              align="center"
            >
              <template slot-scope="scope">
                <div class="t-right">
                  {{ scope.row.refundAmount | numFmt | numDigit  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="backAmount"
              label="本次退款金额(元)"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row.backAmount }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- start of 流程审批 -->
      <div class="back-color-fff mt-4">
        <!-- <span class="form-title">流程审批</span> -->
        <div class="flow">
          <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
      </div>
      <!-- end of 流程审批 -->

      <!-- start of bottom-btn -->
      <div class="back-color-fff submit_btn_wrap">
        <el-button type="defalut" class="cannel-btn" size="mini" @click="$router.go(-1)">取消</el-button>
        <el-button type="danger" size="mini" v-show="getBtnState('approval') == 'approval'" @click="reject()"
          >驳回</el-button
        >
        <el-button type="primary" size="mini" v-show="getBtnState('approval') == 'approval'" @click="pass()"
          >通过</el-button
        >
        <el-button type="primary" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="cancel()"
          >撤销</el-button
        >
        <!-- <el-button type="primary" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit()">重新提交</el-button> -->
      </div>
      <!-- end of bottom-btn -->
    </div>
    <!-- end of form -->

    <!-- end of dialog-驳回 -->
    <el-dialog title="填写驳回备注" :visible.sync="rejectDialogVisible" :width="isLastNode ? '550px' : '430px'">
      <el-input
        style="margin: 10px 0"
        type="textarea"
        :rows="5"
        placeholder="输入驳回理由（必填）"
        v-model="approveSuggest"
        maxlength="100"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-驳回 -->

    <!-- end of dialog-通过 -->
    <el-dialog title="填写通过信息" :visible.sync="passDialogVisible" :width="isLastNode ? '640px' : '430px'">
      <el-form :model="approveForm">
        <template v-if="isLastNode">
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item label-width="110px" style="margin-bottom: 5px">
                <span slot="label"> <span style="color: red">*</span>结算单上传： </span>
                <el-upload
                  class="upload-demo t-left"
                  action="#"
                  ref="settleAttaches"
                  :on-preview="onPreview"
                  :file-list="approveForm.settleAttaches"
                  accept=".xlsx,.docx,.doc,.pdf,.zip,.rar"
                  :auto-upload="true"
                  :http-request="changeMainFile"
                  :limit="5"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="handleMainRemove(file)">删除</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div class="file-preview" @click="onDownload(file)">下载</div>
                  </div>
                  <el-button
                    size="mini"
                    icon="el-icon-my-import"
                    style="margin-top: 8px; margin-bottom: 0"
                    type="importNew"
                    >导入文件</el-button
                  >
                </el-upload>
                <div class="import-step-tip">当前支持word、excel、pdf、zip、rar文件，单个文件大小≤{{ fileSize }}M</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item label-width="110px">
                <span slot="label"> <span style="color: white">*</span>票据上传： </span>
                <el-upload
                  class="upload-demo t-left"
                  action="#"
                  ref="invoiceAttaches"
                  :on-preview="onPreview"
                  :file-list="approveForm.invoiceAttaches"
                  accept=".xlsx,.docx,.doc,.pdf,.zip,.rar"
                  :auto-upload="true"
                  :http-request="changeSubFile"
                  :limit="5"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="handleSubRemove(file)">删除</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div class="file-preview" @click="onDownload(file)">下载</div>
                  </div>
                  <el-button
                    size="mini"
                    icon="el-icon-my-import"
                    style="margin-top: 8px; margin-bottom: 0"
                    type="importNew"
                    >导入文件</el-button
                  >
                </el-upload>
                <div class="import-step-tip">当前支持word、excel、pdf、zip、rar文件，单个文件大小≤{{ fileSize }}M</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label-width="110px">
                <span slot="label"> <span style="color: white">*</span>开票时间： </span>
                <el-date-picker
                  size="mini"
                  style="width: 100%"
                  v-model="approveForm.invoiceDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开票时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label-width="110px">
                <span slot="label"> <span style="color: white">*</span>税率(%)： </span>
                <el-input
                  size="mini"
                  type="text"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  maxlength="5"
                  v-model="approveForm.taxRate"
                  placeholder="请填写税率"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :span="24">
            <el-col :span="24">
              <el-form-item label-width="110px">
                <span slot="label"> <span style="color: white">*</span>备注说明： </span>
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请填写通过备注（选填）"
                  v-model="approveForm.approveSuggest"
                  maxlength="100"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-input
            style="margin: 10px 0"
            type="textarea"
            :rows="5"
            placeholder="请填写通过备注（选填）"
            v-model="approveForm.approveSuggest"
            maxlength="100"
          >
          </el-input>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-通过 -->
  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
import workFlowCommon from '@/uilt/workFlowCommon';
import store from '@/store';
import print from 'print-js';
export default {
  data() {
    return {
      fullscreenLoading: false,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      guid: '',
      formData: {
        relevance: '', // 关联流程
        isPaid:'',
        paidAmount:'',
        returnedAmount:'',
        memo:''
      },

      tableData: [
        {
          key: 1,
          taskContent: '结算金额(元)',
          settleAmount: 'settleAmount',
          memo: '个人结算明细表',
        },
        {
          key: 2,
          taskContent: '结算人数(个)',
          settleAmount: 'personNum',
          memo: '详见结算明细表',
        },
        {
          key: 3,
          taskContent: '服务费(元)',
          settleAmount: 'serviceAmount',
          memo: '服务费费率',
        },
        {
          key: 4,
          taskContent: '结算总额(元)',
          settleAmount: 'totalAmount',
          memo: '结算金额+服务费金额',
        },
      ],

      // 流程图相关
      iframeSh: false,
      iframeSrc: '',

      // 拒绝 通过
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      fileSize: serverConfig.FILE_SIZE,

      approveForm: {
        approveSuggest: null,
        nvoiceDate: null,
        settleAttaches: [], //结算
        invoiceAttaches: [],
        taxRate: null,
      },
      isLastNode: false,
    };
  },
  created() {
    this.guid = this.$route.query.guid;
    this.getDetailData();
    // this.judgeCurrentLastNode();
  },
  watch: {},
  methods: {
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.approveVO && this.formData.approveVO.approveState);
    },
    judgeCurrentLastNode() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let approveVO = JSON.parse(this.$route.query.approveVO);
      console.log(approveVO);
      let req = {
        deploymentId: approveVO.camundaDeploymentId,
        processInstanceId: approveVO.camundaInstanceId,
        staffGuid: userInfo.staffGuid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`, req).then((res) => {
        let { code, data, msg } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.isLastNode = data;
        } else {
          self.$message.error(msg);
        }
      });
    },
    onPreview(file) {
      var fileSuffix;
      if (file.name) {
        fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      }
      if (file.fileName) {
        fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      }

      if (
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf' ||
        fileSuffix === 'zip' ||
        fileSuffix === 'rar'
      ) {
        return window.open(file.path);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    /**
     * 获取对冲详情
     */
    getDetailData() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/downstream/settle/hedge/detail/${self.$route.query.guid}`)
        .then((res) => {
          let { code, data, msg } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.formData = data;
            this.refundDetail = data.refundDetailJson ? JSON.parse(data.refundDetailJson) : [];
            this.getSettleDetail(data)
            this.getApprovalList();
          } else {
            self.$message.error(msg);
          }
        });
    },
    // todo 获取结算的详情
    getSettleDetail(data) {
      let self = this;
      let url = `/downstream/payment/detail`
      let guid = data.settleGuid
      if (data?.billType == 3) {
        // 对账单
        url = `/downstream/statement/detail`
      }
      if (this.formData.isChangeService == 'N') {
        // 原有逻辑
        url = `/downstream/settle/detail`
      }
      self.api
        .get(`/${serverConfig.msSalesPerformService}${url}/${guid}`)
        .then((res) => {
          let { code, data, msg } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let accountMonth = data.accountMonth ? JSON.parse(data.accountMonth) : [];
            // 显示发起人 + 药企简称 + 月份 + 应付金额
            let relevance = data['applyStaffName']
              + ' _ ' + data['tenantName']
              + (accountMonth.length > 0 ? ' _ ' + accountMonth.join(' , ') : '') // 核算月有可能没有
              + (data['payable'] ? (' _ ' + this.formatMoney(data['payable']) + '(元)') : '');
            this.$set(this.formData,'relevance',relevance)
          } else {
            self.$message.error(msg);
          }
        });
    },
    /**
     * 获取操作按钮显隐
     * @param {*} btnType
     */
    getBtnState(btnType) {
      if (this.$route.query.approveVO) {
        let userinfo = JSON.parse(localStorage.userInfo);
        let approveVO = JSON.parse(this.$route.query.approveVO);
        return workFlowCommon.getListBtnState(
          btnType,
          approveVO.approveState,
          approveVO.staffGuid,
          approveVO.approveStaffGuids,
          userinfo.staffGuid,
          approveVO.approveState,
        );
      }
    },
    /**
     * 驳回
     */
    reject() {
      this.rejectDialogVisible = true;
      this.approveSuggest = '';
    },
    /**
     * 通过
     */
    pass() {
      this.passDialogVisible = true;
      this.approveSuggest = '';
    },
    /**
     * 撤销
     */
    cancel() {
      let self = this;
      let { approveVO } = this.formData;
      this.$confirm('撤销后,该流程将不再进行审核,确定这样操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: approveVO.approveGuid,
            flowType: approveVO.flowType,
            approveStaffGuid: approveVO.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    /**
     * 驳回提交
     */
    toRejectSubmit() {
      if (!this.approveSuggest) {
        return this.$message.error('请填写驳回理由');
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      let query = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.approveSuggest = '';
          this.$message.success('驳回成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 通过提交
     */
    toPassSubmit() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      let approveForm = JSON.parse(JSON.stringify(this.approveForm));
      let query = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
        approveSuggest: approveForm.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
      };

      if (this.isLastNode) {
        if (!approveForm.settleAttaches.length) {
          this.$message.error('请上传结算单');
          return;
        }
        if (approveForm.settleAttaches.length) {
          approveForm.settleAttaches.forEach((item) => {
            item.fileName = item.name;
          });
        }
        if (approveForm.invoiceAttaches.length) {
          approveForm.invoiceAttaches.forEach((item) => {
            item.fileName = item.name;
          });
        }
        query = {
          approveSuggest: approveForm.approveSuggest,
          approveStaffGuid: userInfo.staffGuid,
          approveGuid: approveVO.approveGuid,
          guid: this.$route.query.guid,
          settleAttaches: approveForm.settleAttaches,
          invoiceAttaches: approveForm.invoiceAttaches,
          invoiceDate: approveForm.invoiceDate, //票据
          taxRate: approveForm.taxRate, //税率
        };
        this.fullscreenLoading = true;
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/downstream/payment/submit-approve-last`, query)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.passDialogVisible = false;
              this.$message.success('审批通过！');
              this.$router.go(-1);
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.passDialogVisible = false;
            this.$message.success('审批通过！');
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    /**
     * 打印
     */
    billPrintClick() {
      let str = '结算单';
      const style = '@page {margin:0 10mm};'; //打印时去掉眉页眉尾
      printJS({
        printable: 'printBill', // 标签元素id
        type: 'html',
        header: '',
        documentTitle: str,
        targetStyles: ['*'],
        style,
        ignoreElements: ['baseInfo', 'printBtn', 'baseInfo1', 'baseInfo2'],
      });
      // 各个配置项
      // printable:要打印的id。
      // type:可以是 html 、pdf、 json 等。
      // properties:是打印json时所需要的数据属性。
      // gridHeaderStyle和gridStyle都是打印json时可选的样式。
      // repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
      // scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
      // targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
      // style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
      // ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
    },
    /**
     * 查看对账单
     */
    see(url) {
      if (!url) {
        return;
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + url);
    },
    /**
     * 获取流程列表
     */
    getApprovalList() {
      // 00021:结算单流程,00022:付款单流程
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      if (this.guid && approveVO.camundaInstanceId && approveVO.camundaDeploymentId) {
        this.iframeSrc =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          approveVO.camundaInstanceId +
          '&camundaDeploymentId=' +
          approveVO.camundaDeploymentId +
          '&token=' +
          localStorage.token;
        this.iframeSh = true;
        this.$forceUpdate()
        return;
      }
      let req = {
        tenantGuid: localStorage.guid,
        flowType: '00021',
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSrc =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              // console.log(self.iframeSrc);
              self.iframeSh = true;
              this.$forceUpdate()
            } else {
              self.$message.error('未获取到流程信息');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 数字金额转大写
     * @param {*} num
     */
    convertToChinese(num) {
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const decimals = ['角', '分'];
      const cnIntRadice = ['', '拾', '佰', '仟'];
      const cnIntUnits = ['', '万', '亿', '兆'];

      let cnNum = '';
      let isNegative = false;

      if (num < 0) {
        isNegative = true;
        num = Math.abs(num);
      }

      let parts = String(num).split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];

      if (Number(integerPart) === 0) {
        cnNum = digits[0];
        return cnNum;
      }

      let intLen = integerPart.length;
      let zeroCount = 0;

      for (let i = 0; i < intLen; i++) {
        let n = parseInt(integerPart.charAt(i));
        let p = intLen - i - 1;
        let q = p / 4;
        let m = p % 4;

        if (n === 0) {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            cnNum += digits[0];
          }
          zeroCount = 0;
          cnNum += digits[n] + cnIntRadice[m];
        }

        if (m === 0 && zeroCount < 4) {
          cnNum += cnIntUnits[q];
        }
      }

      if (decimalPart) {
        let decLen = decimalPart.length;
        for (let i = 0; i < decLen; i++) {
          let n = parseInt(decimalPart.charAt(i));
          if (n !== 0) {
            cnNum += digits[n] + decimals[i];
          }
        }
      }

      if (isNegative) {
        cnNum = '负' + cnNum;
      }

      return cnNum;
    },
    /********附件上传************/
    // 上传文件
    changeMainFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${this.fileSize}MB`);
        this.$refs.settleAttaches.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.approveForm.settleAttaches.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            console.log(this.approveForm.settleAttaches);
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.approveForm.settleAttaches = [];
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleMainRemove(file) {
      this.approveForm.settleAttaches.forEach((item, index) => {
        if (item.path == file.path) {
          this.approveForm.settleAttaches.splice(index, 1);
        }
      });
    },
    changeSubFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${this.fileSize}MB`);
        this.$refs.invoiceAttaches.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.approveForm.invoiceAttaches.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.approveForm.invoiceAttaches = [];
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleSubRemove(file) {
      this.approveForm.invoiceAttaches.forEach((item, index) => {
        if (item.path == file.path) {
          this.approveForm.invoiceAttaches.splice(index, 1);
        }
      });
    },
    /**
     * 数字金额转大写
     * @param {*} num
     */
    formatMoney(num) {
      if (!num) return '-'
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    seeDetail() {
      let url = '/settlementDocDetail'
      if(this.formData.isChangeService == 'Y' && this.formData.billType == 3){
        // 对账单
        url = '/settlementBillDetail'
      }
      if (this.formData.isChangeService == 'Y' && this.formData.billType != 3) {
        // 付款单
        url = '/downstreamPaymentDetail'
      }
      url += '?guid=' + this.formData.settleGuid;
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.import-step-tip {
  text-align: left;
  font-size: 12px;
  line-height: 20px;
}

.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
  word-break: keep-all;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
    padding-bottom: 10px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 500;
    }

    /deep/ .el-row {
      margin: 0px !important;
    }

    .el-form-item {
      margin-bottom: 0px;
    }

    .over-label /deep/ .el-form-item__label {
      line-height: 21px;
    }

    .el-input {
      width: 220px;
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }

  .detail-box {
    height: auto;
    border: 1px solid rgba(217, 217, 217, 1);
    margin: 0px 16px;
    padding: 16px 16px 100px 16px;
  }

  .cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .file-img-box {
    display: flex;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
      margin-right: 10px;
    }

    .see-btn {
      font-size: 14px;
      color: #4fa1a4;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 400;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  .flex-between,
  .form-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form-title-box {
    padding-right: 16px;
  }

  h2 {
    text-align: center;
  }

  .txt-right {
    text-align: right;

    span {
      margin: 0px 16px;
    }
  }

  .table1 {
    border: 1px solid rgba(229, 229, 229, 1);
    .header-div {
      background: #f2f2f2;
      font-size: 12px;
      color: #909399;
      letter-spacing: 0;
      text-align: center;
      font-weight: bold;
      height: 32px;
      line-height: 32px;
      border: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-label {
      padding: 0px 10px;
      width: 280px;
      height: 32px;
      color: #212121;
      line-height: 32px;
      background: #fafafa;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
      border-left: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-value {
      text-align: right;
      padding: 0px 10px;
      width: calc(100% - 320px);
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
      color: #666666;
    }

    p {
      color: #666666;
    }

    .line-box {
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      padding-left: 10px;

      div:first-child {
        width: 80px;
        background: #fafafa;
        // border-top: 1px solid rgba(229, 229, 229, 1);
        border-right: 1px solid rgba(229, 229, 229, 1);
        font-weight: bold;
      }

      div:last-child {
        padding: 10px 6px;
        width: calc(100% - 80px);

        // border-top: 1px solid rgba(229, 229, 229, 1);
      }
    }
  }

  .table2,
  .table3 {
    width: 100%;
    td {
      padding: 6px;
      border: 1px solid rgba(229, 229, 229, 1);
      border-right: 0 none;
      border-top: 0 none;
    }
    th {
      border: 1px solid rgba(229, 229, 229, 1);
      border-right: 0 none;
      background: #f2f2f2;
      padding: 6px;
    }
    td:last-child {
      border-right: 1px solid rgba(229, 229, 229, 1);
    }
  }

  .table2 {
    margin: 16px 0px;
  }

  .info-box {
    width: 390px;
  }
}
.wth800 {
  width: 800px;
}
.approve-img {
  position: absolute;
  top: 10%;
  right: 60px;
  width: 78px;
  height: 78px;
}
</style>
